export enum AgentSelectionMode {
    AllAgents,
    IncludeSpecific,
    ExcludeSpecific
}